import { h as h2 } from 'preact';
import { cssAbbr, kvCb, strStyle } from '../texdown/src/css';

export const pp = (...p) => {
  const p2 = {};
  p.forEach(a => {
    if (typeof a === 'object') {
      if (typeof a.style === 'string') a.style = strStyle(a.style);
      if (p2.style && a.style) Object.assign(p2.style, a.style);
      Object.assign(p2, a);
      return;
    }
    if (typeof a !== 'string') return;
    const arr = a.split('|');
    /* eslint-disable no-cond-assign */
    arr.forEach(x => {
      let m;
      if (m = x.match(/^\.(.*)/)) p2.className = m[1];
      else if (m = x.match(/^#(.*)/)) p2.id = m[1];
      else if (m = x.match(/:/)) {
        if (!p2.style) p2.style = {};
        strStyle(x, p2.style);
      }
      /* eslint-enable no-cond-assign */
    });
  });
  return p2;
};
pp.cssAbbr = cssAbbr;
pp.strStyle = strStyle;
pp.kvCb = kvCb;

export const h = (t, p, ...c) => {
  let p2 = p;
  if (Array.isArray(p)) p2 = pp(...p);
  if (typeof p === 'string') p2 = pp(p);
  return h2(t, p2, ...c);
};
